import { Command } from 'z3k-parser/model/z3k-config';
export function findOrCreateCommandInConfig(config, command) {
    const find_command = config.commands?.find((_command) => _command.cmd === command.cmd && _command.objectid === command.objectid);
    if (find_command != null) {
        return [find_command.id, config];
    }
    return Command.get.add(config, command);
}
